import { Injectable } from '@angular/core';
import { AlertController, Platform, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    public platform: Platform,
    private toastController: ToastController,
    private alertController: AlertController
  ) { }

  public isBrowser() {
    return !this.platform.is('cordova') && !this.platform.is('capacitor');
  }

  public async showToast(message: string, type: 'success' | 'error' = 'success', duration: number = 3000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'top',
      color: type === 'success' ? 'primary' : 'danger',
      translucent: true,
    });
    await toast.present();
  }

  public async showAlert(
    message: string,
    header: string = 'Error',
    color: 'valid' | 'invalid',
    duration?: number
  ): Promise<void> {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK'],
      cssClass: `alert-${color}`,
    });
  
    await alert.present();
  
    if (duration) {
      // Automatically dismiss after timeout OR wait for manual dismiss
      await Promise.race([
        alert.onDidDismiss(),
        new Promise<void>((resolve) =>
          setTimeout(async () => {
            try {
              await alert.dismiss();
            } catch (e) {} // suppress errors if already dismissed
            resolve();
          }, duration)
        ),
      ]);
    } else {
      await alert.onDidDismiss(); // Normal dismiss flow
    }
  }
  
}
